function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var createPlugin$1 = {};
var createPlugin = {};
var hasRequiredCreatePlugin$1;
function requireCreatePlugin$1() {
  if (hasRequiredCreatePlugin$1) return createPlugin;
  hasRequiredCreatePlugin$1 = 1;
  (function(exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "default", {
      enumerable: true,
      get: function() {
        return _default;
      }
    });
    function createPlugin2(plugin2, config2) {
      return {
        handler: plugin2,
        config: config2
      };
    }
    createPlugin2.withOptions = function(pluginFunction, configFunction = () => ({})) {
      const optionsFunction = function(options) {
        return {
          __options: options,
          handler: pluginFunction(options),
          config: configFunction(options)
        };
      };
      optionsFunction.__isOptionsFunction = true;
      optionsFunction.__pluginFunction = pluginFunction;
      optionsFunction.__configFunction = configFunction;
      return optionsFunction;
    };
    const _default = createPlugin2;
  })(createPlugin);
  return createPlugin;
}
var hasRequiredCreatePlugin;
function requireCreatePlugin() {
  if (hasRequiredCreatePlugin) return createPlugin$1;
  hasRequiredCreatePlugin = 1;
  (function(exports) {
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    Object.defineProperty(exports, "default", {
      enumerable: true,
      get: function() {
        return _default;
      }
    });
    const _createPlugin = /* @__PURE__ */ _interop_require_default(requireCreatePlugin$1());
    function _interop_require_default(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    const _default = _createPlugin.default;
  })(createPlugin$1);
  return createPlugin$1;
}
var plugin$1;
var hasRequiredPlugin;
function requirePlugin() {
  if (hasRequiredPlugin) return plugin$1;
  hasRequiredPlugin = 1;
  let createPlugin2 = requireCreatePlugin();
  plugin$1 = (createPlugin2.__esModule ? createPlugin2 : { default: createPlugin2 }).default;
  return plugin$1;
}
var pluginExports = requirePlugin();
const plugin = /* @__PURE__ */ getDefaultExportFromCjs(pluginExports);
var src;
var hasRequiredSrc;
function requireSrc() {
  if (hasRequiredSrc) return src;
  hasRequiredSrc = 1;
  const plugin2 = requirePlugin();
  const baseStyles = {
    overflow: "hidden",
    display: "-webkit-box",
    "-webkit-box-orient": "vertical"
  };
  const lineClamp2 = plugin2(
    function({ matchUtilities, addUtilities, theme: theme2, variants }) {
      const values = theme2("lineClamp");
      matchUtilities(
        {
          "line-clamp": (value) => ({
            ...baseStyles,
            "-webkit-line-clamp": `${value}`
          })
        },
        { values }
      );
      addUtilities(
        [
          {
            ".line-clamp-none": {
              "-webkit-line-clamp": "unset"
            }
          }
        ],
        variants("lineClamp")
      );
    },
    {
      theme: {
        lineClamp: {
          1: "1",
          2: "2",
          3: "3",
          4: "4",
          5: "5",
          6: "6"
        }
      },
      variants: {
        lineClamp: ["responsive"]
      }
    }
  );
  src = lineClamp2;
  return src;
}
var srcExports = requireSrc();
const lineClamp = /* @__PURE__ */ getDefaultExportFromCjs(srcExports);
const tokens = {
  "breakpoint": {
    "xs": "23.125rem",
    "sm": "36rem",
    "md": "53.25rem",
    "lg": "60.5rem",
    "xl": "67.5rem",
    "2xl": "75rem",
    "3xl": "96.25rem"
  },
  "action": {
    "primary": {
      "default": "#111111",
      "hovered": "#888888",
      "pressed": "#e7e7e7",
      "disabled": "#e7e7e7"
    },
    "secondary": {
      "default": "#ffffff",
      "hovered": "#d1d1d1",
      "pressed": "#e7e7e7",
      "disabled": "#e7e7e7"
    },
    "critical": {
      "default": "#ff1332",
      "hovered": "#ff8c9b",
      "pressed": "#ff4b62",
      "disabled": "#e7e7e7"
    }
  },
  "background": {
    "primary": "#ffffff",
    "secondary": "#f7f8f5",
    "tertiary": "#fbf7ee",
    "inverse": "#111111"
  },
  "border": {
    "primary": {
      "default": "#e7e7e7",
      "hovered": "#b0b0b0",
      "active": "#3d3d3d",
      "disabled": "#e7e7e7"
    },
    "critical": {
      "default": "#ffbbc4",
      "hovered": "#ff4b62",
      "active": "#ff1332",
      "disabled": "#e7e7e7"
    }
  },
  "icon": {
    "default": "#111111",
    "subtle": "#888888",
    "disabled": "#b0b0b0",
    "inverse": "#ffffff",
    "critical": "#ff1332"
  },
  "color": {
    "caramel": {
      "50": "#fbf7ee",
      "100": "#f7f0dd",
      "200": "#eeddba",
      "300": "#e3c58e",
      "400": "#d7a660",
      "500": "#ce8e41",
      "600": "#c07836",
      "700": "#9f5e2f",
      "800": "#804c2c",
      "900": "#684026",
      "950": "#381f12"
    },
    "green": {
      "50": "#ebfef6",
      "100": "#d0fbe6",
      "200": "#a4f6d3",
      "300": "#6aebbc",
      "400": "#2fd8a0",
      "500": "#0abf89",
      "600": "#009b70",
      "700": "#008060",
      "800": "#03624a",
      "900": "#04503f",
      "950": "#012d25"
    },
    "yellow": {
      "50": "#fefde8",
      "100": "#fffec2",
      "200": "#fffa88",
      "300": "#ffef43",
      "400": "#ffde10",
      "500": "#efc403",
      "600": "#d8a000",
      "700": "#a46d04",
      "800": "#87550c",
      "900": "#734510",
      "950": "#432405"
    },
    "sage": {
      "50": "#f7f8f5",
      "100": "#ebeee6",
      "200": "#d6dbcd",
      "300": "#bec5ac",
      "400": "#a4ac8b",
      "500": "#949c73",
      "600": "#8a8f67",
      "700": "#757757",
      "800": "#61624a",
      "900": "#50503e",
      "950": "#2a2a20"
    },
    "blue": {
      "50": "#f0f8fe",
      "100": "#deeefb",
      "200": "#c4e4f9",
      "300": "#9bd3f5",
      "400": "#6cbaee",
      "500": "#499de8",
      "600": "#3483dc",
      "700": "#2e72d2",
      "800": "#2959a4",
      "900": "#264c82",
      "950": "#1c304f"
    },
    "red": {
      "50": "#ffeff1",
      "100": "#ffdadf",
      "200": "#ffbbc4",
      "300": "#ff8c9b",
      "400": "#ff4b62",
      "500": "#ff1332",
      "600": "#ff0021",
      "700": "#e6001e",
      "800": "#bd0019",
      "900": "#930114",
      "950": "#56000b"
    },
    "neutral": {
      "0": "#ffffff",
      "50": "#f6f6f6",
      "100": "#e7e7e7",
      "200": "#d1d1d1",
      "300": "#b0b0b0",
      "400": "#888888",
      "500": "#6d6d6d",
      "600": "#5d5d5d",
      "700": "#4f4f4f",
      "800": "#454545",
      "900": "#3d3d3d",
      "950": "#111111",
      "1000": "#000000"
    },
    "alpha-black": {
      "50": "rgba(0, 0, 0, 0.02)",
      "100": "rgba(17, 17, 17, 0.04)",
      "200": "rgba(17, 17, 17, 0.08)",
      "300": "rgba(17, 17, 17, 0.12)",
      "400": "rgba(17, 17, 17, 0.16)",
      "500": "rgba(17, 17, 17, 0.24)",
      "600": "rgba(17, 17, 17, 0.32)",
      "700": "rgba(17, 17, 17, 0.48)",
      "800": "rgba(17, 17, 17, 0.64)",
      "900": "rgba(17, 17, 17, 0.8)"
    }
  },
  "surface": {
    "primary": {
      "default": "#f6f6f6",
      "hovered": "#e7e7e7",
      "active": "#e7e7e7",
      "disabled": "#b0b0b0"
    },
    "secondary": {
      "default": "#f7f8f5",
      "hovered": "#ebeee6",
      "active": "#d6dbcd",
      "disabled": "#ebeee6"
    },
    "tertiary": {
      "default": "#fbf7ee",
      "hovered": "#f7f0dd",
      "active": "#eeddba",
      "disabled": "#f7f0dd"
    },
    "critical": {
      "default": "#ffbbc4",
      "hovered": "#ff8c9b",
      "active": "#ff1332",
      "disabled": "#ffdadf"
    }
  },
  "text": {
    "default": "#111111",
    "subtle": "#888888",
    "disabled": "#b0b0b0",
    "inverse": "#ffffff",
    "critical": "#ff1332",
    "decorative": "#949c73"
  },
  "elevation": {
    "1": {
      "x": 0,
      "y": 2,
      "color": "rgba(17, 17, 17, 0.12)",
      "blur": 4,
      "spread": 0,
      "type": "dropShadow"
    },
    "2": {
      "x": 0,
      "y": 4,
      "color": "rgba(17, 17, 17, 0.12)",
      "blur": 8,
      "spread": 0,
      "type": "dropShadow"
    },
    "3": {
      "x": 0,
      "y": 8,
      "color": "rgba(17, 17, 17, 0.12)",
      "blur": 16,
      "spread": 0,
      "type": "dropShadow"
    },
    "4": {
      "x": 0,
      "y": 16,
      "color": "rgba(17, 17, 17, 0.12)",
      "blur": 32,
      "spread": 0,
      "type": "dropShadow"
    }
  },
  "radius": {
    "xs": "0.25rem",
    "sm": "0.5rem",
    "md": "1rem",
    "lg": "1.5rem",
    "circle": "62.5rem"
  },
  "spacing": {
    "0": "0",
    "1": "0.25rem",
    "2": "0.5rem",
    "3": "0.75rem",
    "4": "1rem",
    "5": "1.25rem",
    "6": "1.5rem",
    "7": "1.75rem",
    "8": "2rem",
    "9": "2.25rem",
    "10": "2.5rem",
    "11": "2.75rem",
    "12": "3rem",
    "13": "3.25rem",
    "14": "3.5rem",
    "15": "3.75rem",
    "16": "4rem",
    "17": "4.25rem",
    "18": "4.5rem",
    "19": "4.75rem",
    "20": "5rem"
  },
  "font-family": {
    "base": "'Inter Tight', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
    "display": "'ivypresto-display', serif"
  },
  "font-size": {
    "xs": "0.625rem",
    "sm": "0.75rem",
    "md": "0.875rem",
    "lg": "1rem",
    "xl": "1.125rem",
    "2xl": "1.25rem",
    "3xl": "1.5rem",
    "4xl": "1.75rem",
    "5xl": "2rem",
    "6xl": "2.25rem",
    "7xl": "2.5rem"
  },
  "font-weight": {
    "light": 300,
    "regular": 400,
    "medium": 500,
    "semi-bold": 600,
    "bold": 700
  },
  "letter-spacing": {
    "none": "0",
    "md": "0.00125rem",
    "lg": "0.0025rem"
  },
  "line-height": {
    "0": "0",
    "xs": "1rem",
    "sm": "1.25rem",
    "md": "1.5rem",
    "lg": "1.75rem",
    "xl": "2rem",
    "2xl": "2.5rem",
    "3xl": "3rem",
    "4xl": "4rem",
    "5xl": "4.5rem",
    "button": "1rem"
  }
};
const normaliseSizeValue = (value, unit = "px") => {
  if (typeof value === "number") {
    return `${value}px`;
  }
  return /^\+?(0|[1-9]\d*)$/.test(value) ? `${value}${unit}` : value;
};
const createShadows = (elevation) => Object.entries(elevation).reduce(
  (prev, [key, { x = 0, y = 0, blur = 0, spread = 0, color: color2 = "black" }]) => ({
    ...prev,
    [key]: [
      normaliseSizeValue(x),
      normaliseSizeValue(y),
      normaliseSizeValue(blur),
      normaliseSizeValue(spread),
      color2
    ].join(" ")
  }),
  {}
);
const theme = {
  spacing: tokens.spacing,
  fontFamily: tokens["font-family"],
  fontSize: tokens["font-size"],
  fontWeight: Object.entries(tokens["font-weight"]).reduce(
    (prev, [key, value]) => ({ ...prev, [key]: value.toString() }),
    {}
  ),
  lineHeight: tokens["line-height"],
  letterSpacing: tokens["letter-spacing"],
  borderRadius: tokens.radius,
  color: {
    ...tokens.color,
    ...tokens.text,
    icon: tokens.icon,
    action: tokens.action
  },
  backgroundColor: {
    ...tokens.background,
    surface: tokens.surface,
    action: tokens.action
  },
  borderColor: tokens.border,
  screens: tokens.breakpoint,
  boxShadow: createShadows(tokens.elevation)
};
const { color, backgroundColor, borderColor, ...baseThemeProperties } = theme;
const config = {
  content: ["src/**/*.{js,jsx,ts,tsx}", "../../packages/**/*.{js,ts,jsx,tsx}"],
  darkMode: "class",
  theme: {
    ...baseThemeProperties,
    extend: {
      colors: {
        ...color,
        facebook: "#1778F2",
        twitter: "#1DA1F2",
        pintrest: "#E60023"
      },
      backgroundColor,
      borderColor
    }
  },
  plugins: [
    lineClamp,
    plugin(function({ addVariant }) {
      const prefix = "ui";
      for (const state of [
        "open",
        "checked",
        "selected",
        "active",
        "disabled"
      ]) {
        addVariant(`${prefix}-${state}`, [
          `&[data-ui-state~="${state}"]`,
          `:where([data-ui-state~="${state}"]) &`
        ]);
        addVariant(`${prefix}-not-${state}`, [
          `&[data-ui-state]:not([data-ui-state~="${state}"])`,
          `:where([data-ui-state]:not([data-ui-state~="${state}"])) &:not([data-ui-state])`
        ]);
      }
    }),
    plugin(function({ addUtilities }) {
      addUtilities([
        {
          ".contain-layout": {
            contain: "layout"
          }
        }
      ]);
    })
  ],
  safelist: [
    "md:hidden",
    "lg:hidden",
    "display-desktop-only",
    "display-mobile-only"
  ]
};
export {
  config,
  theme
};
